"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPostAdd = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=post&icon=post_add&style=baseline
const IconPostAdd = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("g", { id: "Bounding_Box" },
            react_1.default.createElement("rect", { fill: "none", width: "24", height: "24" })),
        react_1.default.createElement("g", { id: "Flat" },
            react_1.default.createElement("g", { id: "ui_x5F_spec_x5F_header_copy_2" }),
            react_1.default.createElement("g", null,
                react_1.default.createElement("path", { d: "M17,19.22H5V7h7V5H5C3.9,5,3,5.9,3,7v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-7h-2V19.22z" }),
                react_1.default.createElement("path", { d: "M19,2h-2v3h-3c0.01,0.01,0,2,0,2h3v2.99c0.01,0.01,2,0,2,0V7h3V5h-3V2z" }),
                react_1.default.createElement("rect", { x: "7", y: "9", width: "8", height: "2" }),
                react_1.default.createElement("polygon", { points: "7,12 7,14 15,14 15,12 12,12 \t\t" }),
                react_1.default.createElement("rect", { x: "7", y: "15", width: "8", height: "2" })))));
};
exports.IconPostAdd = IconPostAdd;
